import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone } from 'lucide-react';
import { cvData } from '../mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-charcoal text-off-white">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          {/* About */}
          <div>
            <h3 className="text-xl font-bold mb-4 text-copper">Asia B. Jewell</h3>
            <p className="text-warm-grey text-sm leading-relaxed">
              Interdisciplinary artist exploring ADOS identity, Wake Work, and ancestral memory through performance, video, and material practice.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/projects" className="text-warm-grey hover:text-copper transition-colors">
                  Projects
                </Link>
              </li>
              <li>
                <Link to="/sonic" className="text-warm-grey hover:text-copper transition-colors">
                  Sonic Artifacts
                </Link>
              </li>
              <li>
                <Link to="/thesis" className="text-warm-grey hover:text-copper transition-colors">
                  Echoes of the Ninth
                </Link>
              </li>
              <li>
                <Link to="/research" className="text-warm-grey hover:text-copper transition-colors">
                  Research
                </Link>
              </li>
              <li>
                <Link to="/cv" className="text-warm-grey hover:text-copper transition-colors">
                  CV
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact</h3>
            <div className="space-y-3 text-sm">
              <div className="flex items-center">
                <Mail className="h-4 w-4 text-copper mr-2 flex-shrink-0" />
                <a href={`mailto:${cvData.contact.email[0]}`} className="text-warm-grey hover:text-copper transition-colors">
                  {cvData.contact.email[0]}
                </a>
              </div>
              <div className="flex items-center">
                <Phone className="h-4 w-4 text-copper mr-2 flex-shrink-0" />
                <a href={`tel:${cvData.contact.phone}`} className="text-warm-grey hover:text-copper transition-colors">
                  {cvData.contact.phone}
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-warm-grey/20 pt-8 text-center text-sm text-warm-grey">
          <p>&copy; {currentYear} Asia B. Jewell. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;